import { Button } from "@aircall/tractor";
import { styled } from "@xstyled/styled-components";

export const StyledButton = styled(Button)`
  display: block;
  padding: 12px 16px;
  height: auto;
  color: #004736;
  background: #5bf1b2;
  text-decoration: none;
  border: 0;
  border-radius: sm;
  white-space: nowrap;
`;
